import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
interface FooterProps {
  onPrivacyClick: () => void;
  onTermsClick: () => void;
}
export function Footer({
  onPrivacyClick,
  onTermsClick
}: FooterProps) {
  const {
    t
  } = useTranslations();
  return <footer className="bg-white text-gray-900 pt-16 pb-8" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="flex flex-col items-center text-center space-y-6 mb-10" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/oxFWMvdwUBRjCt1riBg7DA/Asset_44x.png" alt="Brixen Funding" className="h-8 w-auto" data-id="element-97" />

          <div className="space-y-3" data-id="element-98">
            <a href="mailto:info@brixenfunding.com" className="flex items-center justify-center gap-3 text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-99">
              <Mail className="w-4 h-4" data-id="element-100" />
              info@brixenfunding.com
            </a>
            <a href="tel:7862726132" className="flex items-center justify-center gap-3 text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-101">
              <Phone className="w-4 h-4" data-id="element-102" />
              (786) 272-6132
            </a>
          </div>

          <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-103">
            <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-104">
              Facebook
            </a>
            <span data-id="element-105">•</span>
            <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-106">
              Instagram
            </a>
            <span data-id="element-107">•</span>
            <a href="#" className="hover:text-gray-900 transition-colors" data-id="element-108">
              WhatsApp
            </a>
          </div>

          <div className="space-y-3 max-w-3xl pt-4" data-id="element-109">
            <p className="text-[10px] text-gray-500 leading-relaxed" data-id="element-110">
              {t('footer.disclaimer1')}
            </p>
            <p className="text-[10px] text-gray-500 leading-relaxed" data-id="element-111">
              {t('footer.disclaimer2')}
            </p>
            <p className="text-[10px] text-gray-500 leading-relaxed" data-id="element-112">
              {t('footer.disclaimer3')}
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-113">
          <div className="flex items-center gap-4 text-xs text-gray-500" data-id="element-114">
            <button onClick={onPrivacyClick} className="hover:text-gray-900 transition-colors" data-id="element-115">
              {t('footer.privacy')}
            </button>
            <button onClick={onTermsClick} className="hover:text-gray-900 transition-colors" data-id="element-116">
              {t('footer.terms')}
            </button>
          </div>

          <p className="text-xs text-gray-500" data-id="element-117">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>;
}